export const UPDATE_SOURCE = 'UPDATE_SOURCE'
export const UPDATE_CODE_GENERATION_OPTIONS = 'UPDATE_CODE_GENERATION_OPTIONS'



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js